<template>
  <div class="animated fadeIn">

    
    <b-card class="card-accent-info" header="Solicitações REST">
      <b-card-body>

        <b-row>
          <b-col cols="auto" class="mr-auto">
              <!--
              <b-form-group>
                  <b-button variant="outline-primary" :pressed.sync="tableSelectable">{{tableSelectable ? 'Desabilitar Seleção ' : 'Habilitar Seleção'}}</b-button>
                  &nbsp;
                  <b-button variant="outline-primary" v-show="tableSelectable" @click="selectAllRows">Selecionar todos</b-button>
                  &nbsp;
                  <b-button variant="outline-primary" v-show="tableSelectable" @click="clearSelectedRows">Limpar seleção</b-button>
            </b-form-group>
            -->
          </b-col>
          <b-col cols="auto" class="">
            <b-form-group>
              <!-- <b-button variant="vine" class="mr-1 btn-brand" @click="openServerModal()"><i class="fa fa-server"></i><span>Novo Servidor</span></b-button> -->
              <b-button variant="github" class="mr-1 btn-brand" @click="openEditModal(null)"><i class="fa fa-plus"></i><span>Nova Solicitação</span></b-button>
            </b-form-group>
          </b-col>
        </b-row>
            

        <b-row>
          <b-col cols="auto">
            <b-form-group>
                <label for="company" style="font-size: 0.8em">Empresa</label>
                <b-form-select id="company"
                  v-model="filters.companyId"
                  :plain="true"
                  :options="companyDDL"
                  @change="changeCompany"
                  >
                </b-form-select>
            </b-form-group>
          </b-col>

          <b-col cols="auto">
            <b-form-group>
                <label for="company" style="font-size: 0.8em">Coleção</label>
                <b-form-select id="collection"
                  v-model="filters.collectionId"
                  :plain="true"
                  :options="collectionDDL"
                 >
                </b-form-select>
            </b-form-group>
          </b-col>

          <b-col cols="auto">
            <b-form-group>
                <label for="name" style="font-size: 0.8em">Filtro</label>
                <b-form-input v-model="filters.key" type="text" id="filter" placeholder="Filtro"></b-form-input>
            </b-form-group>
          </b-col>
          <!--
          <b-col cols="auto" class="mr-auto">
            <b-form-group>
                <label for="name">Filtro</label>
                <b-form-input type="text" id="filter" placeholder="Filtro"></b-form-input>
            </b-form-group>
          </b-col>
        -->
          <b-col cols="auto" class="mr-auto" style="padding-top: 12px;">
            <b-form-group>
              <p></p>
              <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="refreshData()"><i class="fa fa-search"></i><span>Localizar</span></b-button>
            </b-form-group>
          </b-col>

          <b-col cols="auto" class="">
            <b-form-group >
                <label for="perPage" style="font-size: 0.8em">Linhas</label>
                <b-form-select v-model="perPage" id="perPage"
                  :plain="true"
                  :options="[5,10,20,50]">
                </b-form-select>
              </b-form-group>
          </b-col>
          
        </b-row>
      

          <b-table
              :items="filteredItems"
              :fields="fields"
              :select-mode="selectMode"
              responsive="sm"
              ref="selectableTable"
              selectable
              @row-selected="onRowSelected"
              :primary-key="primaryKey"
              :tbody-transition-props="transProps"
              sort-icon-left
              @row-clicked="rowClicked"
              :per-page="perPage"
              :current-page="currentPage"
              :busy="isBusy"
              hover
              striped

              >

              <template #table-busy>
                  <div class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>Carregando...</strong>
                  </div>
              </template>
              
              <!-- Example scoped slot for select state illustrative purposes -->
              <template #cell(selected)="{ rowSelected }">
                  <template v-if="rowSelected">
                  <span aria-hidden="true">&check;</span>
                  <span class="sr-only">Selected</span>
                  </template>
                  <template v-else>
                  <span aria-hidden="true">&nbsp;</span>
                  <span class="sr-only">Not selected</span>
                  </template>
              </template>

              <template #cell(show_details)="row">
                  <b-row>
                      <b-col cols="auto" class="mr-auto">
                          <b-form-group>
                          <b-button size="sm" variant="dark"  @click="row.toggleDetails" class="mr-1 btn-brand"><i class="fa fa-search"></i></b-button>
                        
                          </b-form-group>
                      </b-col>
                  </b-row>
              </template>
              
              <template #row-details="row">
                  <b-card>
                      <b-row v-show="row.item.summary && row.item.summary.length > 0">
                          <b-col class="small">Resumo</b-col>
                      </b-row>
                      <b-row>
                          <b-col class="text-primary">{{ row.item.summary }}</b-col>
                      </b-row>
                      <b-row v-show="row.item.content && row.item.content.length > 0">
                          <b-col class="small">Conteúdo</b-col>
                      </b-row>
                      <b-row>
                          <b-col class="text-primary">{{ row.item.content }}</b-col>
                      </b-row>
                      <b-row>
                          <b-col>{{ row.item.content }}</b-col>
                      </b-row>
                      <b-row>
                          <b-col><i>Publicado em <b>{{ row.item.publishedin }}</b> por <b>{{ row.item.publisher }}</b></i></b-col>
                      </b-row>
                  </b-card>
              </template>
              
              <template v-slot:cell(originalValue)="data">
                  {{ !isNaN(data.item.originalValue) ? new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format( data.item.originalValue) : '' }}
              </template>

              <template v-slot:cell(paymentValue)="data">
                  {{ !isNaN(data.item.paymentValue) ? new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format( data.item.paymentValue) : '' }}
              </template>

              <template v-slot:cell(st)="data">
                  <c-switch class="" @change.native="changeStatusClick(data.item)" color="primary" :checked="data.item.st=='A'" label variant="pill" v-bind="switchLabelIcon" /> 
              </template>
              
          </b-table>
          <nav>
              <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="Anterior" next-text="Próximo" />
          </nav>


      </b-card-body>
   </b-card>

   <b-modal
            v-model="serverModal"
            id="server-modal"
            centered
            hide-footer
            title="Servidor"
            size="lg">

      <b-card>

        <b-form @submit.stop.prevent="onSubmit">
  
        <div class="animated fadeIn">

          <b-row>
            <b-col md="12">
                <b-form>
                    <b-form-group
                    description=""
                    label="Servidor"
                    label-for="serverName"
                    >
                    <b-form-input v-model="selectedServer.name" id="serverName" type="text"></b-form-input>
                </b-form-group> 
                </b-form>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="12">
                <b-form>
                    <b-form-group
                    description=""
                    label="URL"
                    label-for="serverUrl"
                    >
                    <b-form-input v-model="selectedServer.url" id="serverUrl" type="text"></b-form-input>
                </b-form-group> 
                </b-form>
            </b-col>
          </b-row>


        </div>

        </b-form>

        <div slot="footer" class="text-right">
            <b-button variant="github" class="mr-1 btn-brand" @click="saveServer()"><i class="fa fa-check"></i><span>Salvar Servidor</span></b-button>
          
        </div>

      </b-card>
    </b-modal>

   <b-modal
            v-model="editModal"
            id="edit-modal"
            centered
            hide-footer
            title="Solicitação REST"
            size="xl">

      <b-card>

        <b-form @submit.stop.prevent="onSubmit">
  
        <div class="animated fadeIn">
      
          <b-row>
            <b-col md="4">
              <b-form>
                <b-form-group
                    description=""
                    label="Coleção"
                    label-for="collection"
                    >
                    <b-form-select id="collection"
                      v-model="selectedItem.collectionId"
                      :plain="true"
                      :options="collectionDDL"
                    >
                    </b-form-select>
                </b-form-group>
                

              </b-form>

            </b-col>
          </b-row>

          <b-row>
            <b-col md="12">
                <b-form>
                    <b-form-group
                    description=""
                    label="Nome da Solicitação"
                    label-for="sourceModelFolder"
                    >
                    <b-form-input v-model="selectedItem.name" id="sourceModelFolder" type="text"></b-form-input>
                </b-form-group> 
                </b-form>
            </b-col>
          </b-row>

          <b-row>
              <b-col md="12">
                  <b-form>
                      <b-form-group
                      description=""
                      label="Servidor"
                      label-for="server"
                      >
                      <b-row>
                        <b-col md="4">
                          <b-form-select id="server"
                            v-model="serverId"
                            :plain="true"
                            :options="serverDDL"
                            value="">
                          </b-form-select>
                        </b-col>
                       
                        <b-col>
                          {{  serverUrl  }}
                        </b-col>

                        <b-col md="2">
                          <b-button variant="github" class="mr-1 btn-brand" @click="openServerModal()"><i class="fa fa-plus"></i><span>Novo Servidor</span></b-button>
                        </b-col>
                      </b-row>
                      
                  </b-form-group> 
                  </b-form>
              </b-col>
          </b-row>

          <b-row>
              <b-col md="12">
                  <b-form>
                      <b-form-group
                      description=""
                      label="URL"
                      label-for="httpMode"
                      >
                      <b-row>
                        <b-col md="2">
                          <b-form-select id="httpMode"
                            v-model="selectedItem.httpVerbsId"
                            :plain="true"
                            :options="httpModeDDL"
                            value="">
                          </b-form-select>
                        </b-col>
                        <b-col>
                                <b-form-input v-model="selectedItem.requestUrl" id="sourceModelFolder" type="text"></b-form-input>
                           </b-col>
                      </b-row>
                      
                  </b-form-group> 
                  </b-form>
              </b-col>
          </b-row>

  
          <b-row>
              <b-col md="12">
                  <b-form>
                      <b-form-group
                      description=""
                      label="JSON Data"
                      label-for="data"
                      >
                      <textarea v-model="selectedItem.requestBody" class="form-control" id="data" name="data" rows="12" placeholder=""></textarea>
                  </b-form-group> 
                  </b-form>
              </b-col>
          </b-row>

          <b-row>
              <b-col md="12">
                  <b-form>
                      <b-form-group
                      description=""
                      label="Resultado"
                      label-for="resp"
                      >
                      <textarea v-model="response" class="form-control" id="resp" name="data" rows="6" placeholder=""></textarea>                      
                  </b-form-group> 
                  </b-form>
              </b-col>
          </b-row>

          <b-row>
            <b-col md="12">
                  <b-form>
                      <b-form-group
                      description=""
                      label=""
                      label-for="resp"
                      >
                      <b-button variant="flickr" class="mr-1 btn-brand" @click="openMdfeModal()"><i class="fa fa-file-code-o"></i><span>MDFe</span></b-button>               
                  </b-form-group> 
                  </b-form>
              </b-col>
           
          </b-row>

          <b-input-group class="mb-4">
              <div class="text-danger" v-if="this.errorMessage && this.errorMessage != ''"><i class="fa fa-exclamation-triangle fa-lg mt-4"></i> {{ this.errorMessage }}</div>
          </b-input-group>
        
      
          <div slot="footer" class="text-right">
              <b-button variant="spotify" class="mr-1 btn-brand" @click="sendGet()"><i class="fa fa-check"></i><span>Enviar GET</span></b-button>
              <b-button variant="vine" class="mr-1 btn-brand" @click="sendPost()"><i class="fa fa-check"></i><span>Enviar POST</span></b-button>
          
          </div>
                    
        </div>
        </b-form>


        <div slot="footer" class="text-right">
            <!--
            <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="enableDisable()" v-show="this.selectedItem.id && this.selectedItem.st=='I'"><i class="fa fa-times"></i><span>Habilitar</span></b-button>
            <b-button variant="html5" class="mr-1 btn-brand" @click="enableDisable()" v-show="this.selectedItem.id && this.selectedItem.st=='A'"><i class="fa fa-times"></i><span>Desabilitar</span></b-button>
            -->
            <b-button variant="github" class="mr-1 btn-brand" @click="save()"><i class="fa fa-check"></i><span>Salvar Solicitação</span></b-button>
          
        </div>

      </b-card>
      
    </b-modal>




    <b-modal
            v-model="mdfeModal"
            id="mdfe-modal"
            centered
            hide-footer
            title="MDFe"
            size="lg">

      <b-card>

        <b-form @submit.stop.prevent="onSubmit">
  
        <div class="animated fadeIn">

          <b-row>
            <b-col md="12">
                <b-form>
                    <b-form-group
                    description=""
                    label="Código"
                    label-for="mdfeTemplateCode"
                    :label-cols="3"
                    :horizontal="true"
                    >
                    <b-row>
                      <b-col><b-form-input v-model="mdfeTemplate.code" id="mdfeTemplateCode" type="text"></b-form-input></b-col>
                      <b-col cols="2">Nome</b-col>
                      <b-col><b-form-input v-model="mdfeTemplate.name" id="mdfeTemplateName" type="text"></b-form-input></b-col>
                    </b-row>
                </b-form-group> 
                </b-form>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="12">
                <b-form>
                    <b-form-group
                    description=""
                    label="CNPJ"
                    label-for="mdfeTemplateCnpj"
                    :label-cols="3"
                    :horizontal="true"
                    >
                    <b-row>
                      <b-col><b-form-input v-model="mdfeTemplate.cnpj" id="mdfeTemplateCnpj" type="text"></b-form-input></b-col>
                      <b-col cols="2">UF</b-col>
                      <b-col><b-form-input v-model="mdfeTemplate.uf" id="mdfeTemplateUf" type="text"></b-form-input></b-col>
                    </b-row>

                    
                </b-form-group> 
                </b-form>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="12">
                <b-form>
                    <b-form-group
                    description=""
                    label="Latitude"
                    label-for="mdfeTemplateLatitude"
                    :label-cols="3"
                  :horizontal="true"
                    >                    
                    <b-row>
                      <b-col><b-form-input v-model="mdfeTemplate.latitude" id="mdfeTemplateLatitude" type="text"></b-form-input></b-col>
                      <b-col cols="2">Longitude</b-col>
                      <b-col><b-form-input v-model="mdfeTemplate.longitude" id="mdfeTemplateLongitude" type="text"></b-form-input></b-col>
                    </b-row>
                    
                </b-form-group> 
                </b-form>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="12">
                <b-form>
                    <b-form-group
                    description=""
                    label="Direção"
                    label-for="mdfeTemplateDirection"
                    :label-cols="3"
                    :horizontal="true"
                    >
                    <b-row>
                      <b-col><b-form-input v-model="mdfeTemplate.direction" id="mdfeTemplateCode" type="text"></b-form-input></b-col>
                      <b-col cols="2">Ambiente</b-col>
                      <b-col><b-form-input v-model="mdfeTemplate.environment" id="mdfeTemplateEnv" type="text"></b-form-input></b-col>
                    </b-row>
                </b-form-group> 
                </b-form>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="12">
                <b-form>
                    <b-form-group
                    description=""
                    label="Equipamento"
                    label-for="mdfeTemplateDirection"
                    :label-cols="3"
                    :horizontal="true"
                    >
                    <b-row>
                      <b-col><b-form-input v-model="mdfeTemplate.equipment" id="mdfeTemplateCode" type="text"></b-form-input></b-col>
                      <b-col cols="2">Certificado</b-col>
                      <b-col><b-form-input v-model="mdfeTemplate.certificate" id="mdfeTemplateEnv" type="text"></b-form-input></b-col>
                    </b-row>
                </b-form-group> 
                </b-form>
            </b-col>
          </b-row>


        </div>

        </b-form>

        <div slot="footer" class="text-right">
            <b-button variant="flickr" class="mr-1 btn-brand" @click="createMdfe()"><i class="fa fa-file-code-o"></i><span>Criar JSON MDFe</span></b-button>
        </div>

      </b-card>
    </b-modal>



  </div>

</template>

<script>
import Vue from 'vue'
import axios from "axios";

import { Switch as cSwitch } from '@coreui/vue'

/* Toast */
import VueNotifications from 'vue-notifications'
import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
//import { table } from 'console'

const toastTypes = {
  success: 'success',
  error: 'error',
  info: 'info',
  warn: 'warn'
}

miniToastr.init({types: toastTypes})

function toast ({title, message, type, timeout, cb}) {
  return miniToastr[type](message, title, timeout, cb)
}

const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
}
VueNotifications.setPluginOptions(options)

Vue.use(VueNotifications, options)
/* Toast - End */

const newItem = {id: null, name: '', httpVerbsId: 0, collectionId: 0, requestUrl: "", requestBody: "" }

export default {
  name: 'tables',
  components: {
    Event,
    cSwitch
  },
  data: () => {
    return {

      mdfeModal: false,
      mdfeTemplate: { "uf": 35 },

      serverModal: false,
      selectedServer: { name: '', url: '' },

      response: "",
      serverId: 0,
      serverDDL: [],
      collectionDDL: [],
      companyDDL: [],
      httpModeDDL: [],

      isBusy: false,
      currentPage: 1,
      switchLabelIcon: {
          dataOn: '\u2713',
          dataOff: '\u2715'
      },
      switchLabelTxt: {
          dataOn: 'yes',
          dataOff: 'no'
      },

      tableRef: "table",
      tableSelectable: false,
      errorMessage: '',
      editModal: false,
      filters: {
        companyId: 0,
        collectionId: 0,
        key: ''
      },

      modes: ['multi', 'single', 'range'],
      selectMode: 'multi',
      selected: [],
      transProps: {
        // Transition name
        name: 'flip-list'
      },
      primaryKey: "id",

      selectedItem: newItem,
      items: [        
      ],
      fields: [
        //{key: 'show_details', label: "", thStyle: { width: "40px" } },
        //{key: 'id' },
        //{key: 'costcenter', label: 'Centro de Custo', sortable: true, thStyle: { width: "200px" }  },
        {key: 'collectionName', label: 'Coleção', sortable: true, thStyle: { width: "250px" } },
        {key: 'name', label: 'Solicitação', sortable: true },
        {key: 'httpVerbsCode', label: 'Modo', sortable: true , thStyle: { width: "150px" }, class: 'text-center'  },
        {key: 'requestUrl', label: 'Url', sortable: true , thStyle: { width: "400px" } },
        //{key: 'document', label: 'Renavam', sortable: true, thStyle: { width: "150px" } },
        //{key: 'dueDate', label: 'Data', sortable: true, class: 'text-center', thStyle: { width: "150px" }},
        //{key: 'originalValue', label: 'Valor', sortable: true, class: 'text-right', thStyle: { width: "150px" }},
        //{key: 'paymentValue', label: 'Valor Pago', sortable: true, class: 'text-right', thStyle: { width: "150px" } },
        //{key: 'odometer', label: 'Km', sortable: false, thStyle: { width: "100px" } },
        //{key: 'serviceTotal', label: 'Serviços', sortable: false, thStyle: { width: "40px" } },
        //{key: 'statusName', label: 'Status', sortable: true, class: 'text-center', thStyle: { width: "150px" } }
        {key: 'st', label: 'Status', sortable: true, thStyle: { width: "40px" } }
      ],
      
      filterable: ['username'],
      sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
      perPage: 20
    }
  },
  computed: {
    serverUrl() {
      if(this.serverId && parseInt(this.serverId) > 0) {
        return this.serverDDL.find(obj => parseInt(obj.value) === parseInt(this.serverId)).label 
      }
      return ""
    },

    totalRows: function () { return this.getRowCount() },
    filteredItems() {
      try {
          return this.items.filter(item => {
            return this.filters.key == '' || item.name.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1
          })
      }
      catch(e) {
          return this.items;
      }
    }
  },
  methods: {

    getRowCount: function () {
      if(this.items)
          return this.items.length
      else
          return 0;
    },

    
    async saveServer() {
      var s = this;
      

      if(this.selectedServer && this.selectedServer.url && this.selectedServer.name && this.selectedServer.url.length > 0 && this.selectedServer.name.length > 0) {

        var currentUser = this.$store.state.currentUser
        this.selectedServer.companyId = this.filters.companyId
        this.selectedServer.uid = currentUser.id
        this.selectedServer.sid = currentUser.sid

        await axios.post(
          this.$store.state.ws_url + "/restapi/server",
          this.selectedServer
        ).then(function() {
            s.closeServerModal()
            s.getServer()
            s.selectedServer.name = ""
            s.selectedServer.url = ""
        }).catch(function(error) {
            console.log(error)
            toast({
                type: VueNotifications.types.error,
                title: 'Servidor',
                message: 'Erro ao salvar servidor',
                timeout: 5000
            })
        });

      }
      else {
        toast({
              type: VueNotifications.types.error,
              title: 'Servidor',
              message: 'Preencha os campos obrigatórios: Servidor e URL',
              timeout: 5000
          })
      }
    },

    changeStatusClick(item) {
      if(item != null) {
        if(item.st == 'A') 
          item.st = 'I'; 
        else 
          item.st = 'A';

        this.saveItem(item);
      }
    },

    async saveItem(currentItem) {

      var s = this;
      var postData = { ...currentItem };

      postData.companyId = this.filters.companyId
      postData.uid = this.$store.state.currentUser.id
      postData.sid = this.$store.state.currentUser.sid
       
      console.log(postData)

      await axios.post(
          this.$store.state.ws_url + "/restapi/request",
          postData
      ).then(function() {
          s.closeEditModal()
          s.refreshData();
      }).catch(function(error) {
          toast({
              type: VueNotifications.types.warn,
              title: 'Solicitação Rest',
              message: 'Sem permissão de acesso.',
              timeout: 5000
          })
      });

    },

  
    save() {
      let msgError = [];

      if(!this.selectedItem.collectionId || this.selectedItem.collectionId <= 0)
          msgError.push("Coleção");

      if(this.selectedItem.name.length <= 2)
          msgError.push("Nome da Solicitação");
      
      if(msgError.length > 0) {
          let msgErrorExt = "Verifique os campos: ";
          let msgErrorSep = "";
          msgError.forEach(function(element) { msgErrorExt += msgErrorSep + element; msgErrorSep=", "; } )

          toast ({
              type: VueNotifications.types.error,
              title: 'Campos Obrigatórios',
              message: msgErrorExt,
              timeout: 5000
          })
      }
      else {
          this.saveItem(this.selectedItem);
      }
    },
    enableDisable() {
      console.log('Habilitando/desabilitando modelo')
      console.log(this.selectedItem);
    },

    closeMdfeModal() {
      this.mdfeModal = false
    },
    openMdfeModal() {
      this.mdfeModal = true
    },

    closeServerModal() {
      this.serverModal = false;
    },
    openServerModal() {
      this.selectedServer = { name: '', url: '' }
      this.serverModal = true;
    },
    closeEditModal() {
      this.editModal = false;
    },
    openEditModal(item) {
      if(item == null) {
          this.selectedItem = { ...newItem };      
      }
      else {
          this.selectedItem = JSON.parse(JSON.stringify(item));
      }
      this.editModal = true;
    },
    onRowSelected(items) {
      this.selected = items
      //console.log(items);
      //this.openEditModal(items[0])
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows();
    },
    clearSelectedRows() {
      this.$refs.selectableTable.clearSelected();
    },
    rowClicked(item) {
      if(!this.tableSelectable) {
          this.clearSelectedRows();
          this.openEditModal(item);
      }
    },
    getBadge (status) {
      return status === 'A' ? 'primary'
          : status === 'I' ? 'danger'
          : status === 'Pending' ? 'warning'
              : status === 'Banned' ? 'danger' : 'primary'
    },
    toggleBusy() {
      this.isBusy = !this.isBusy
    },

    createMdfe() {
      console.log("Criar Json MDFe")
    },

    async getServer() {
      var s = this;
      var currentUser = this.$store.state.currentUser;
      await axios.get(
          this.$store.state.ws_url + "/restapi/server/ddl?companyId=" + s.filters.companyId  + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
      ).then(function(resp) {
        s.serverDDL = resp.data.obj;
      }).catch(function(error) {
        s.serverDDL = []
      })      
    },

    async getHttpMode() {
      var s = this;
      var currentUser = this.$store.state.currentUser;

      await axios.get(
          this.$store.state.ws_url + "/restapi/httpverbs/ddl?uid=" + currentUser.id + "&sid=" + currentUser.sid
      ).then(function(resp) {
        s.httpModeDDL = resp.data.obj;
      }).catch(function(error) {
        s.httpModeDDL = []
      })      
    },

    async getCollection() {
      var s = this;
      var currentUser = this.$store.state.currentUser;

      
  
      await axios.get(
          this.$store.state.ws_url + "/restapi/collection/ddl?companyId=" + s.filters.companyId  + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
      ).then(function(resp) {
        s.collectionDDL = resp.data.obj;
      }).catch(function(error) {
        s.collectionDDL = []
      })      
    },

    async refreshData() {
      this.isBusy = true;
      var s = this;
      var currentUser = this.$store.state.currentUser;
  
      await axios.get(
          this.$store.state.ws_url + "/restapi/request?companyId=" + s.filters.companyId  + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
      ).then(function(resp) {
          s.items = resp.data.obj;
      }).catch(function(error) {
        
      })      
      this.isBusy = false;
    
    },
    changeCompany() {
      this.getHttpMode();
      this.getServer();
      this.getCollection();
      this.refreshData();
    },

    async sendPost() {
      var s = this;
      var postData = JSON.parse(this.selectedItem.requestBody)
      var url = this.serverUrl + this.selectedItem.requestUrl

      console.log(url)
      console.log(postData)

      await axios.post(
        url,
        postData
      ).then(function(resp) {
        console.log(resp)
        s.response = resp
      }).catch(function(error) {
        console.log(error)
        s.response = error
      })

    }

  },
  mounted: function() {
    this.companyDDL = this.$store.state.currentUser.companies
    this.filters.companyId = this.$store.state.currentUser.companyId
    this.changeCompany()
  }
}
</script>

<style scoped>
table#table-transition-example .flip-list-move {
transition: transform 1s;
}
</style>